import React from "react";
import './AccountControl.css';
import FullPagePanel from "components/reusable/FullPagePanel";
import AccountSettingsTabs from "components/account-screen/AccountSettingsTabs";
import LoginForm from "components/account-screen/LoginForm";
import Constants from "utilities/js/Constants";
import CookieManager from "utilities/js/localstorage/CookieManager";
import { freezeBody, unfreezeBody } from "utilities/js/styling/domUtilities";
import { isLoggedIn } from "utilities/js/ActionLibrary";

const accountIcon = Constants.ICON_ACCOUNT;


const cookieManager = new CookieManager();

class AccountControl extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            disableFixed: props.disableFixed != null ? true : false
        };

        this.toggleAccountPanel = this.toggleAccountPanel.bind(this);
        this.closeAccountPanel = this.closeAccountPanel.bind(this);
        this.getAccountPanelDisplay = this.getAccountPanelDisplay.bind(this);
    }

    get buttonContainerClass() {
        return 'account-button-container ' + (this.state.disableFixed ? 'inline' : 'fixed');
    }


    toggleAccountPanel() {
        if (this.state.isOpen) {
            this.setState({ isOpen: false });
            unfreezeBody();
        } else {
            this.setState({ isOpen: true });
            freezeBody();
        }
    }

    closeAccountPanel() {
        this.setState({ isOpen: false });
        unfreezeBody();
    }

    getAccountPanelDisplay() {
        if (isLoggedIn()) {
            return (<AccountSettingsTabs></AccountSettingsTabs>)
        } else {
            return (<LoginForm closePanel={this.closeAccountPanel} navigateHomeOnLogin={this.props.navigateHomeOnLogin}></LoginForm>);
        }
    }
    get accountButton() {
        let username = cookieManager.getValue(Constants.COOKIE_USERNAME_KEY);

        if (username) {//TODO: Evaluate if we still want this, and if we do, removed false
            return (
                <div className={this.buttonContainerClass}>
                    <div className="account-button" onClick={this.toggleAccountPanel}>
                        <img className="account-icon" alt="account-icon" src={accountIcon}></img>
                    </div>
                </div>
            )
        } else {
            return (
                <div key="login-register-button" className="login-register-button-container">
                    <div className="login-register-button" onClick={this.toggleAccountPanel}>Login</div>
                </div>
            )
        }
    }

    render() {

        return (
            <>
                <FullPagePanel shouldDisplay={this.state.isOpen} closePanel={this.closeAccountPanel}>
                    {this.getAccountPanelDisplay()}
                </FullPagePanel>
                {this.accountButton}
            </>
        )
    }
}

export default AccountControl;
